export default __webpack_public_path__ + "static/media/logo-short.b5f8024a.svg";